<template>
  <div class="brand-page">
    <div class="table-toolbar">
      <el-row :gutter="15">
        <el-col :span="12">
          <div class="table-toolbar-left">   
            <el-form :inline="true" size="small">
              <el-form-item>
                <el-input v-model="query.search" placeholder="请输入品牌名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getBrandList()">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="table-toolbar-right">
            <el-button v-if="disabled1" type="primary" @click="addBrand()" size="small">新增品牌</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="tablebox">
      <el-table v-loading="loading" :data="tablelist" tooltip-effect="dark" size="small">
        <el-table-column prop='brandId' label="ID" width="60"></el-table-column>
        <el-table-column prop='name' label="名称(中)" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop='brand' label="名称(En)" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="Logo" width="100">
          <template slot-scope="scope">
            <el-button type="info" @click="viewLogoImg(scope.row.logo)" size="mini">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="关键词">
          <template slot-scope="scope">
            {{ scope.row.keywords }}
            <!-- <a :href="scope.row.url" target="_blank">查看</a> -->
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <!-- status: 0禁用；1启用 -->
            {{ scope.row.status===1 ? '启用' : '停用' }}
          </template>
        </el-table-column>
        <el-table-column prop='subscriptions' label="订阅数" width="100"></el-table-column>
        <el-table-column v-if="disabled1" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editBrand(scope.row)">修改</el-button>
            <el-popconfirm v-if="scope.row.status/1===1" confirm-button-text="暂停" cancel-button-text="取消" title="确定暂停吗？" @confirm="suspendBrand(scope.row.brandId, 0)">
              <el-button type="danger" slot="reference" size="mini">暂停</el-button>
            </el-popconfirm>
            <el-popconfirm v-if="scope.row.status/1===0" confirm-button-text="启用" cancel-button-text="取消" title="确定启用吗？" @confirm="suspendBrand(scope.row.brandId, 1)">
              <el-button type="warning" slot="reference" size="mini">启用</el-button>
            </el-popconfirm>
            <!-- <el-button v-if="scope.row.status/1 === 1" type="warning" size="mini" @click="suspendBrand(scope.row.brandId, 0)">暂停</el-button>
            <el-button v-if="scope.row.status/1 === 0" type="success" size="mini" @click="suspendBrand(scope.row.brandId, 1)">启用</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table-pagination">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="query.size"
        layout="total, prev, pager, next, sizes"
        :total="totalbrand">
      </el-pagination>      
    </div>

    <el-dialog
      title="修改品牌"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="editBrandDialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="editform" :rules="brandrules" ref="editbrandform" label-width="120px" size="small">
          <el-form-item label="品牌名称(中)" prop="name">
            <el-col :span="24">
              <el-input v-model="editform.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌名称(英)" prop="brand">
            <el-col :span="24">
              <el-input v-model="editform.brand"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Logo">
            <el-col :span="12">
              <el-input v-model="editform.logo"></el-input>
            </el-col>
            <el-col :span="12">
              <el-upload
                :show-file-list="false"
                class="upload-logo"
                name="logo"
                :limit="999"
                :action="uploadlogourl"
                :headers="uploadlogoheaders"
                :on-success="uploadsuccess">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>              
            </el-col>
          </el-form-item>
          <el-form-item label="关键词" prop="keywords">
            <el-col :span="24">
              <el-input type="textarea" :rows="2" v-model="editform.keywords"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌序列号">
            <el-col :span="24">
              <el-input v-model="editform.trademark"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog('editbrandform')" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmEditBrand('editbrandform')" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增品牌"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="addBrandDialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="addform" :rules="brandrules" ref="addbrandform" label-width="120px" size="small">
          <el-form-item label="品牌名称(中)" prop="name">
            <el-col :span="24">
              <el-input v-model="addform.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌名称(英)" prop="brand">
            <el-col :span="24">
              <el-input v-model="addform.brand"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Logo">
            <el-col :span="12">
              <el-input v-model="addform.logo"></el-input>
            </el-col>
            <el-col :span="12">
              <el-upload
                :show-file-list="false"
                class="upload-logo"
                name="logo"
                :limit="999"
                :action="uploadlogourl"
                :headers="uploadlogoheaders"
                :on-success="uploadsuccess">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>              
            </el-col>
          </el-form-item>
          <el-form-item label="关键词" prop="keywords">
            <el-col :span="24">
              <el-input type="textarea" :rows="2" v-model="addform.keywords"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌序列号">
            <el-col :span="24">
              <el-input v-model="addform.trademark"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog('addbrandform')" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmAddBrand('addbrandform')" size="small" :disabled="disableaddbtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="viewlogodialog"
      title="查看Logo"
      :visible.sync="viewlogo"
      width="400px">
      <div id="brandlogoid"></div>
    </el-dialog>

  </div>
</template>

<script>
export default {

  data(){
    return{
      loading: false,
      query: {
        search: '',
        page: 1,
        size: this.getLocalStorage('pagesize2') ? this.getLocalStorage('pagesize2') * 1 : 25,
      },
      currentPage: 1,
      tablelist: [],
      totalbrand: 0,
      editBrandDialog: false,
      addBrandDialog: false,
      editform: {
        brandid: '',
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      },
      uploadlogourl: this.API_URL + '/sys/brand/upload',
      uploadlogoheaders: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
      addform: {
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      },
      viewlogo: false,
      disableaddbtn: false,
      brandrules: {
        name: { required: true, message: '不能为空', trigger: 'blur' },
        brand: { required: true, message: '不能为空', trigger: 'blur' },
      },
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false
    }
  },

  mounted(){
    this.getBrandList()
  },

  methods: {

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize2', val)
      that.getBrandList()
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      that.getBrandList()
    },

    /**
     * 获取品牌列表
     */
    getBrandList: function(){
      let that = this
      let url = that.API_URL + '/sys/brand/list'
      let query = that.query
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBrandList', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(function(res){
            res.subscriptions = 0
          })
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getBrandList', response)
        }
      })
    },

    /**
     * 暂停品牌弹窗
     */
    editBrand: function(row){
      // console.log(row)
      let that = this
      that.editform = {
        brandid: row.brandId,
        name: row.name,
        brand: row.brand,
        logo: row.logo,
        keywords: row.keywords,
        trademark: row.trademark,
      }
      that.editBrandDialog = true      
    },

    /**
     * 暂停品牌
     */
    suspendBrand: function(bid, status){
      let that = this
      let url = that.API_URL + '/sys/brand/ban'
      let query = {
        brandid: bid,
        status: status
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('suspendBrand', data)
          that.getBrandList()
        },
        error: function(response) {
          console.log('suspendBrand', response)
        }
      })
    },

    /**
     * 隐藏对话框
     */
    cancelDialog: function(refs){
      let that = this
      that.editform = {
        brandid: '',
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      },
      that.addform = {
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      }
      that.$refs[refs].resetFields(refs)
      that.editBrandDialog = false
      that.addBrandDialog = false
    },

    /**
     * 确认修改品牌
     */
    confirmEditBrand: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          let url = that.API_URL + '/sys/brand/edit'
          let query = that.editform
          $.ajax({
            url: url,
            type: "PUT",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('confirmEditBrand', data)
              that.editBrandDialog = false
              that.$refs[refs].resetFields(refs)
              that.getBrandList()
            },
            error: function(response) {
              console.log('confirmEditBrand', response)
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * 新增品牌
     */
    addBrand: function(){
      let that = this
      that.disableaddbtn = false
      that.addform = {
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      }
      that.addBrandDialog = true
    },

    /**
     * 确认新增品牌
     */
    confirmAddBrand: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          that.disableaddbtn = true
          that.getBrand(that.addform.name, function(rs){
            if(rs){
              let url = that.API_URL + '/sys/brand/add'
              let query = that.addform
              $.ajax({
                url: url,
                type: "POST",
                headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
                changeOrigin: true,
                crossDomain: true,
                data: query,
                success: function(data) {
                  console.log('confirmAddBrand', data)
                  that.addBrandDialog = false
                  that.$refs[refs].resetFields(refs)
                  that.getBrandList()
                },
                error: function(response) {
                  console.log('confirmAddBrand', response)
                }
              })
            }else{        
              that.$message({
                offset: 80,
                message: "品牌已经存在",
                type: 'error'
              })
              that.disableaddbtn = false
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * 上传成功
     */
    uploadsuccess: function(response, file, fileList){
      let that = this
      that.editform.logo = response.result
      that.addform.logo = response.result
      console.log('uploadsuccess', response)
      console.log('uploadsuccess', file)
      console.log('uploadsuccess', fileList)
    },

    /**
     * 查看Logo图片
     */
    viewLogoImg: function(imgurl){
      let that = this
      that.viewlogo = true
      $("#brandlogoid").html("")
      let url = that.API_URL + '/static/files/logos/' + imgurl
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = "blob"
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.onload = function() {
        if (this.status == 200) {
          var blob = this.response;
          var img = document.createElement("img")
          img.onload = function(e) {
            window.URL.revokeObjectURL(img.src)
            console.log(e)
          }
          img.src = window.URL.createObjectURL(blob);
          $("#brandlogoid").html(img)
        }
      }
      xhr.send()
    },

    /**
     * 查找品牌
     */
    getBrand: function(brand, callback){
      let that = this
      let url = that.API_URL + '/sys/brand/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: brand, type: 0},
        success: function(data) {
          console.log('getBrand', data)
          let availablebrand = data.results.length === 0 ? true : false
          callback(availablebrand)
        },
        error: function(response) {
          console.log('getBrand', response)
        }
      })
    },

  },

}
</script>
